/*
	This is a reducer that ONLY HOUSES ANALYTICS calls.
	It contains no internal state.
	It only subscribes to the actions in the signup ducks file,
	and composes the state to
*/

import isApp from "shared/util/isApp";
import Analytics from "./util/Analytics";

import {
	UPLOAD_DETAILS_SUCCESS,
} from "ducks/photo_upload";


// ////////////////////////
// REDUCER ///////////////
// //////////////////////

export default function photoUpload(state, action) {
	switch (action.type) {
		case UPLOAD_DETAILS_SUCCESS: {
			// only check this on MW
			// on desktop, it'll be recorded by OkPhotos
			// on the apps, it'll be recorded by the native photo uploader

			if (process.env.PLATFORM === "mobile" && !isApp()) {
				const data = {
					"source of upload": "onboarding",
					"photo count": 1,
				};

				Analytics.logUIEvent(
					Analytics.eventNames.uploadedPhoto,
					{ data },
				);
			}

			return;
		}

		default: {
			return;
		}
	}
}



// WEBPACK FOOTER //
// ./src/analytics/photo_upload.js